import { request } from "axios/request";
import {
  FETCH_MISC_PRODUCT_PENDING,
  FETCH_MISC_PRODUCT_FULFILLED,
  FETCH_MISC_PRODUCT_REJECTED,
} from "constants/miscProduct";

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const miscProductPending = () => ({
  type: FETCH_MISC_PRODUCT_PENDING,
});
const miscProductFulfilled = (response) => ({
  type: FETCH_MISC_PRODUCT_FULFILLED,
  response: response,
});
const miscProductRejected = (error) => ({
  type: FETCH_MISC_PRODUCT_REJECTED,
  error: error,
});

export const getMiscProduct = (productSku) => (dispatch) => {
  dispatch(miscProductPending());

  request({
    method: "GET",
    url: $U.MISC_PRODUCT.replace("{0}", productSku),
  })
    .then((response) => {
      dispatch(miscProductFulfilled(response.data));
    })
    .catch((error) => {
      dispatch(miscProductRejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/miscProduct.js